/* eslint-disable  @typescript-eslint/no-explicit-any */
import type { MiddlewarePipeDetails } from '../../models/middleware-pipe-details.model';
import type { SearchApi } from '../../../../api/model/response/ApiResponse';
import type { StackMiddlewareRequest } from '../../models/stack-middleware-request.model';
import type { SearchTab } from '../../../../components/result-page/search-tab/search-tab';
import axios, {type AxiosRequestConfig } from 'axios';
import { makeLogger } from '../../../../logger/logger';
import type {DashboardMisspellings} from '../../../../components/result-page/search-tab/subcomponents/dashboard-tab-view/dashboard-misspellings/dashboard-misspellings';
import type { PipeMiddlewareElement, PipeMiddlewareNext } from '../../middleware-pipe';

const { debug, err } = makeLogger({
  pathToCurrentFile:'utils/middleware-pipe/pipes/api-calls/call-cose-api.ts',
  loggersList: ['debug', 'err']
});

export const callCoseApi = async (
  details: MiddlewarePipeDetails,
  next?: PipeMiddlewareNext<any>,
  middlewareDepth?: number,
  middlewareArray?: Array<PipeMiddlewareElement<MiddlewarePipeDetails, any>>
): Promise<SearchApi> => {
    debug('PIPE_MIDDLEWARE callCoseApi', details);

    const stackMiddlewareRequest: StackMiddlewareRequest = details.middlewareRequest;
    const searchTab: SearchTab | DashboardMisspellings = details.context;

    const createUrl = (endpoint: string) => {
        try {
          const searcherSuffix = searchTab.tabTitle ? ('tab-' + searchTab.tabTitle) : '';
          const middlewareSuffux = details.middlewareRequest.middlewareSuffix ?? '';
          const url = new URL(endpoint);
          url.searchParams.append('ui-component', searcherSuffix + middlewareSuffux );
          return url.href;
        } catch (e) {
          err(`unable to create url from  ${endpoint}`);
          return '';
        }
    };

    const url = createUrl(stackMiddlewareRequest.apiEndpoint);

    const config: AxiosRequestConfig = {
      method: (stackMiddlewareRequest.method) ? stackMiddlewareRequest.method : 'POST',
      url: url,
      headers: {},
      data: details.middlewareRequest.requestBody,
      validateStatus: function (status) {
          return status === 200;
      }
    };

    const apiGeeToken: string | undefined = searchTab.apigeeBearer || details.additionalData?.token;

    if(!apiGeeToken && details.additionalData?.authHeader){
      config.headers['Authorization'] = details.additionalData?.authHeader;
    }

    if (apiGeeToken) {
      config.headers['Authorization'] = 'Bearer ' + apiGeeToken;
    }

    if (searchTab.token) {
      config.headers['X-IDMS-Authorization'] = searchTab.token;
    }

    ////[SVS-30337] Turn off write for Search History for public
    // const tealiumId = extractTealiumId(getCookieValue('TEAL'));
    // if (tealiumId) {
    //   config.headers['X-TEAL-User'] = tealiumId;
    // }

    const apigeeValue = new URLSearchParams(window.location.search).get('apigee');
    if(apigeeValue == 'monitoring'){
      config.headers['Bypass-Cache'] = 'true';
    }

    if (searchTab.apiKey) {
      config.headers.apikey = searchTab.apiKey;
    }

    if(details.additionalData && details.additionalData?.headers) {
      details.additionalData.headers.forEach((headerData) => {
          const keys = Object.keys(headerData);
          if(keys && !config.headers.hasOwnProperty(keys[0])) {
            config.headers[keys[0]] = headerData[keys[0]];
          }
      });
    }

    return axios.request<SearchApi>(config)
      .then((response) => {
          return response.data as SearchApi;
      }).catch((error) => {
          searchTab.notifyAboutApiErrorResponse(error);
          return error;
      });
};
